// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store/store' 
// import 'lib-flexible/flexible'
import './assets/js/flexible'
import dataV from '@jiaminghi/data-view'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(dataV)

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,  //store:store 和router一样，将我们创建的Vuex实例挂载到这个vue实例中
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js